import styled from "styled-components";
import {Paper} from "@material-ui/core";

export const PaperStyled = styled(Paper)`
  background: transparent;
  border-radius: 10px;
`;